<script>
import { eventGroupState } from "@app/store/eventGroupStore.svelte.js";
import { projectState } from "@app/store/projectStore.svelte.js";
import { insertHistoryAction } from "@app/store/historyStore.svelte.js";
import * as m from "@app/paraglide/messages.js";

const TRACK_LETTERS = ["A", "B", "C", "D"];

/** @type {{event?: any, disabled?: boolean}} */
let { event = $bindable({}), disabled = false } = $props();

function updateTrack(value) {
    if (disabled) return;

    event.track = TRACK_LETTERS.includes(value) ? value : false;

    insertHistoryAction({
        name: "update event track",
        eventGroup: projectState.selected,
        snapshots: [
            {
                store: "eventGroupState",
                value: JSON.stringify(eventGroupState),
            },
        ],
    });
}
</script>

{#if TRACK_LETTERS.includes(event.track)}
<select
    id="eventTrackSelect-{event.id}"
    class="select-form form-control-sm rounded border-0 event-track-select"
    aria-label={m.event_track_select_aria_label()}
    title={m.event_track_select_title()}
    value={event.track}
    {disabled}
    onclick={(clickEvent) => clickEvent.stopPropagation()}
    onchange={(changeEvent) => updateTrack(changeEvent.currentTarget.value)}>
    <option value="">{m.event_track_none()}</option>
    {#each TRACK_LETTERS as letter (letter)}
        <option value={letter}>{m.multiview_track()} {letter}</option>
    {/each}
</select>
{/if}

<style lang="css">
.event-track-select {
    max-width: 110px;
}
</style>
